const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: 117 }, (_, i) => {
  const year = String(currentYear - i);
  return {
    label: year,
    value: year,
  };
});

export const dayOptions = Array.from({ length: 31 }, (_, i) => ({
  label: String(i + 1),
  value: (i + 1).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  }),
}));

export const monthOptions = [
  {
    label: 'January',
    value: '01',
  },
  {
    label: 'February',
    value: '02',
  },
  {
    label: 'March',
    value: '03',
  },
  {
    label: 'April',
    value: '04',
  },
  {
    label: 'May',
    value: '05',
  },
  {
    label: 'June',
    value: '06',
  },
  {
    label: 'July',
    value: '07',
  },
  {
    label: 'August',
    value: '08',
  },
  {
    label: 'September',
    value: '09',
  },
  {
    label: 'October',
    value: '10',
  },
  {
    label: 'November',
    value: '11',
  },
  {
    label: 'December',
    value: '12',
  },
];
